import { bannerItems } from "src/mockData/bannerItems";
import bannerImg from "src/assets/adminSideBanner.png";

const AdminBanner = () => {
  return (
    <div
      className="rounded-2xl bg-black translate-y-80 md:translate-y-0  fixed inset-0 my-4 ml-4 h-[45vh] md:h-[calc(100vh-12%)] w-full md:w-[72vw]  transition-transform duration-300 md:translate-x-[26vw] mt-[5rem] overflow-hidden  bg-cover bg-no-repeat bg-center"
      style={{ backgroundImage: `url(${bannerImg})`, backgroundSize: "85% 100%", backgroundPosition: "left" }}
    ></div>
  );
};

export default AdminBanner;
